import React, { FC } from "react";
import { Download, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface Props {
  selectedCount: number;
  onExport: () => void;
  onClear: () => void;
}

export const UsersBulkActions: FC<Props> = ({
  selectedCount,
  onExport,
  onClear,
}) => {
  const { t } = useTranslation();

  if (selectedCount <= 0) {
    return null;
  }

  return (
    <div
      className="flex items-center gap-3"
      role="region"
      aria-label={t("users.bulk.label", "Bulk actions")}
    >
      <span className="text-foreground text-sm font-medium" aria-live="polite">
        {t("users.bulk.selected", "{{count}} selected", {
          count: selectedCount,
        })}
      </span>
      <Button type="button" variant="new_outline" onClick={onExport}>
        <Download />
        {t("users.bulk.export", "Export")}
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-8 w-8 p-0"
        onClick={onClear}
        title={t("users.bulk.clear", "Clear selection")}
        aria-label={t("users.bulk.clear", "Clear selection")}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
